var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useRef, useCallback } from 'react';
import { FiSearch, FiXCircle, FiCompass, FiEdit2 } from 'react-icons/fi';
import { components } from 'react-select';
import CustomAsync from '../select/async';
import { SearchWrapper, OptionIconWrapper, OptionLabel, OptionContainer, ClearButtonWrapper } from './styles';
var SearchBar = function (_a) {
    var placeholder = _a.placeholder, _b = _a.width, width = _b === void 0 ? '100%' : _b, loadOptions = _a.loadOptions, onChange = _a.onChange;
    var _c = useState(null), selectedOption = _c[0], setSelectedOption = _c[1];
    var selectRef = useRef(null);
    var handleClear = useCallback(function () {
        var _a;
        setSelectedOption(null);
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.clearValue();
    }, [onChange]);
    var CustomSingleValue = function (props) { return React.createElement(components.SingleValue, __assign({}, props)); };
    var CustomOption = React.memo(function (props) {
        var data = props.data, innerRef = props.innerRef, innerProps = props.innerProps;
        return (React.createElement(OptionContainer, __assign({ ref: innerRef }, innerProps),
            React.createElement(OptionIconWrapper, null,
                data.value === 'current_location' && React.createElement(FiCompass, { size: 16 }),
                data.value === 'manual_entry' && React.createElement(FiEdit2, { size: 16 }),
                !data.isCustom && data.value !== 'manual_entry' && data.value !== 'current_location' && (React.createElement(FiSearch, { size: 16 }))),
            React.createElement(OptionLabel, null, data.label)));
    });
    CustomOption.displayName = 'CustomOption';
    return (React.createElement(SearchWrapper, { width: width },
        React.createElement(CustomAsync, { ref: selectRef, cacheOptions: true, defaultOptions: true, loadOptions: loadOptions, placeholder: placeholder, components: {
                Option: CustomOption,
                SingleValue: CustomSingleValue,
                DropdownIndicator: function () { return null; },
            }, leftIcon: React.createElement(FiSearch, null), rightIcon: selectedOption && (React.createElement(ClearButtonWrapper, { onClick: handleClear },
                React.createElement(FiXCircle, null))), noOptionsMessage: function () { return 'Address not found'; }, onChange: function (option) {
                setSelectedOption(option);
                onChange === null || onChange === void 0 ? void 0 : onChange(option);
            }, value: selectedOption, isRounded: true, touched: true, showIndicatorSeparator: false })));
};
export default SearchBar;
